(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-service', {
            parent: 'dac-content-main',
            url: '/nasrac-service',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracService.home.title'
            },
            templateUrl: 'app/dac-content/nasrac-service/nasrac-services.html',
            controller: 'NasracServiceController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-service.new', {
            parent: 'dac-content-main.nasrac-service',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-service/nasrac-service-dialog.html',
                    controller: 'NasracServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            //    bsgHandle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                }, function() {
                    $state.go('dac-content-main.nasrac-service');
                });
            }]
        })
        .state('dac-content-main.nasrac-service.unusedBsgList', {
                parent: 'dac-content-main',
                url: '/bsgList',
                data: {
                    authorities: roles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/dac-content/nasrac-service/nasrac-service-unusedBsg-dialog.html',
                        controller: 'NasracUnusedDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    //    bsgHandle: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                    }, function() {
                        $state.go('dac-content-main.nasrac-service');
                    });
                }]
        })
        .state('dac-content-main.nasrac-service.edit', {
            parent: 'dac-content-main.nasrac-service',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-service/nasrac-service-dialog.html',
                    controller: 'NasracServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracService', function(NasracService) {
                            return NasracService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-service.delete', {
            parent: 'dac-content-main.nasrac-service',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-service/nasrac-service-delete-dialog.html',
                    controller: 'NasracServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracService', function(NasracService) {
                            return NasracService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
